import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const blurb = (d) => d.intro || (d.n_teorie ? `${d.n_teorie} teorie da leggere e confrontare.` : "Teorie da leggere e confrontare.");

export function useVoted() {
  const [voted, setVoted] = useState(() => new Set());
  useEffect(() => { api.get("/me/voted").then((r) => setVoted(new Set(r.data))).catch(() => {}); }, []);
  return voted;
}
